/**
 * *Sledovať* / *Sledované* for one entity, wherever the entity is shown (graph panel, a person's
 * page). It reads the case's watchlists, which the Monitor page shares, so both stay in step.
 * Nothing renders for an entity without a stable `_uid` (ADR-0091), nor while the lists load.
 */
import { WatchToggleButton } from '@/components/monitor/WatchToggleButton'
import { canChangeWatching, isWatched } from './monitor-rows'
import { pendingUid, useWatchChange, useWatchlists } from './useMonitor'

export interface WatchToggleProps {
  caseId: string
  entity: { uid: string | null; label: string | null; entityType: string | null }
}

export function WatchToggle({ caseId, entity }: WatchToggleProps) {
  const watchlists = useWatchlists(caseId)
  const change = useWatchChange(caseId)
  const { uid } = entity
  if (!uid || !watchlists.data) return null

  const watched = isWatched(watchlists.data.watchlists, uid)
  const toggle = () =>
    change.mutate(
      watched
        ? { action: 'unwatch', uid }
        : { action: 'watch', entity: { uid, label: entity.label, entity_type: entity.entityType } }
    )
  return (
    <WatchToggleButton
      watched={watched}
      pending={pendingUid(change.variables, change.isPending) === uid}
      onToggle={canChangeWatching(watchlists.data.member_role) ? toggle : null}
    />
  )
}
